import { render, staticRenderFns } from "./__id.vue?vue&type=template&id=98c124f4"
import script from "./__id.vue?vue&type=script&lang=js"
export * from "./__id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports